import { Container } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useContext, useState } from "react";
import { useScreenSize } from "src/hooks/useScreenSize";
import { LocalizationContext } from "../../lib/context";
import FilterItem from "../FilterPopup/FilterItem";
import FilterItemMobile from "../FilterPopup/FilterItemMobile";

export interface IFilterItem {
  name:
    | "location"
    | "equipment"
    | "free-range"
    | "max-range"
    | "certification"
    | "";
  translation: string;
}

const items: IFilterItem[] = [
  { name: "location", translation: "Where" },
  { name: "equipment", translation: "Equipment" },
  { name: "free-range", translation: "Free range" },
  { name: "max-range", translation: "Max range" },
  { name: "certification", translation: "Certification" },
];

const SearchBox = ({
  setFilter,
  filter,
  setQuery,
  hideFilters = false,
}: {
  setFilter: (e: any) => void;
  filter: any;
  setQuery: (e: string) => void;
  hideFilters?: boolean;
}) => {
  const { uiGeneral } = useContext(LocalizationContext).localeStrings;
  const [activeItem, setActiveItem] = useState<IFilterItem>({
    translation: "",
    name: "",
  });

  const updateFilter = (key: string, value: any) => {
    const newFilter = { ...filter };
    newFilter[key] = value;
    setFilter(newFilter);
  };

  const handleChange = (e: any) => {
    setQuery(e.target.value);
  };

  const smAndDown = useScreenSize("sm", "down");
  return (
    <Container className="search-box">
      {!hideFilters && (
        <>
          {!smAndDown && (
            <div className="search-box__top">
              <div className="search-box__categories">
                {items.map((item, i) => (
                  <FilterItem
                    activeItem={activeItem}
                    index={i}
                    item={item}
                    items={items}
                    setActiveItem={setActiveItem}
                    key={item.name + i}
                    setFilterValue={(v) => updateFilter(item.name, v)}
                  />
                ))}
              </div>
              <div className="search-box__iconBox">
                <SearchIcon />
              </div>
            </div>
          )}
          {smAndDown && (
            <div className="search-box__top search-box_mobile__top">
              {items.map((item, i) => (
                <FilterItemMobile
                  activeItem={activeItem}
                  index={i}
                  item={item}
                  items={items}
                  setActiveItem={setActiveItem}
                  key={item.name + i}
                  setFilterValue={(v) => updateFilter(item.name, v)}
                />
              ))}
            </div>
          )}
        </>
      )}
      <div className="search-box__input">
        <input
          type="text"
          placeholder={uiGeneral.searchByText}
          onChange={handleChange}
        />
        <div className="search-box__iconBox">
          <SearchIcon />
        </div>
      </div>
    </Container>
  );
};

export default SearchBox;
